import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgExitRightGhostLine = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M15 21a1 1 0 0 1-1 1c-3.007 0-5.597-.753-7.422-2.578S4 15.007 4 12s.753-5.597 2.578-7.422S10.993 2 14 2a1 1 0 1 1 0 2c-2.7 0-4.69.675-6.008 1.992S6 9.3 6 12s.675 4.69 1.992 6.008S11.3 20 14 20a1 1 0 0 1 1 1'
      clipRule='evenodd'
      opacity={0.2}
    />
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M14.678 7.894a1 1 0 0 0-.617.924V11H9.757a1 1 0 1 0 0 2h4.304v2.182a1 1 0 0 0 1.707.707l3.182-3.182a1 1 0 0 0 0-1.414L15.768 8.11a1 1 0 0 0-1.09-.217'
      clipRule='evenodd'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgExitRightGhostLine)
export default ForwardRef
